import { TypePageTexts } from '@/types/i18n';
import en from '../i18n/en/index.json';
export const GlobalPageTexts: TypePageTexts = {
  en,
};
